import React, { useState } from 'react';
import ProfaseModal from '../../../commons/ProfaseModal';
import { FaPlus } from '@react-icons/all-files/fa/FaPlus';
import { FaArrowsAltH } from '@react-icons/all-files/fa/FaArrowsAltH';
import GrupoContactoTable from './GrupoContactoTable';
import GrupoContactoCrearModal from './GrupoContactoCrearModal';
import GrupoContactoEditarModal from './GrupoContactoEditarModal';
import WindowHeader from '../../../commons/WindowHeader';
import { useAppDispatch } from '../../../store';
import { getEntities as getContactos } from '../../contacto.reducer';
import { buildGrupoPanelTitle, type EmpresaGrupoResumen } from '../grupo-panel-title';

const GrupoContacto = (props: {
    contactos: any;
    grupoId?: string | null;
    empresaId?: string | null;
    empresaSeleccionada?: EmpresaGrupoResumen | null;
    canEditGrupoEmpresas?: boolean;
    filaExpandida?: boolean;
    onToggleFilaExpandida?: () => void;
    onEliminarContacto?: (contacto: any) => void;
}) => {
    const {
        contactos,
        grupoId,
        empresaId,
        empresaSeleccionada,
        canEditGrupoEmpresas = false,
        filaExpandida = false,
        onToggleFilaExpandida,
        onEliminarContacto,
    } = props;
    const dispatch = useAppDispatch();
    const [modalOpen, setModalOpen] = useState(false);
    const [crearOpen, setCrearOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [editContactId, setEditContactId] = useState<number | null>(null);

    const panelTitle = buildGrupoPanelTitle(
        'Contactos',
        filaExpandida ? empresaSeleccionada : null,
    );
    const panelTitleModal = buildGrupoPanelTitle(
        'Contactos',
        filaExpandida || modalOpen ? empresaSeleccionada : null,
    );

    const list = contactos ?? [];

    const refetchContactos = () => {
        if (grupoId == null || grupoId === 'new') return;
        dispatch(
            getContactos({
                grupoId,
                page: 0,
                size: 99999,
                sort: 'id,asc',
            }),
        );
    };

    const openCrearContacto = () => {
        setModalOpen(false);
        setEditOpen(false);
        setEditContactId(null);
        setCrearOpen(true);
    };

    const openEditarContacto = (c: any) => {
        if (c?.id == null) return;
        setModalOpen(false);
        setCrearOpen(false);
        setEditContactId(Number(c.id));
        setEditOpen(true);
    };

    const tableEditHandler = canEditGrupoEmpresas ? openEditarContacto : undefined;
    const tableEliminarHandler =
        canEditGrupoEmpresas && onEliminarContacto ? onEliminarContacto : undefined;

    const expandFilaButton =
        grupoId != null && grupoId !== 'new' && onToggleFilaExpandida != null ? (
            <button
                type="button"
                className="btn btn-sm btn-light d-inline-flex align-items-center justify-content-center"
                style={{ width: 36, height: 32, padding: 0 }}
                title={
                    filaExpandida
                        ? 'Restaurar ancho: mostrar de nuevo servicios junto a contactos'
                        : 'Expandir contactos al 100 % del ancho (ocultar servicios en esta fila)'
                }
                aria-label={
                    filaExpandida
                        ? 'Contraer panel de contactos'
                        : 'Expandir panel de contactos a ancho completo'
                }
                onClick={() => onToggleFilaExpandida()}
            >
                <FaArrowsAltH />
            </button>
        ) : null;

    const plusButton =
        grupoId != null && grupoId !== 'new' ? (
            <button
                type="button"
                className="btn btn-sm btn-light d-inline-flex align-items-center justify-content-center"
                style={{ width: 36, height: 32, padding: 0 }}
                disabled={!canEditGrupoEmpresas}
                title={
                    canEditGrupoEmpresas
                        ? 'Agregar contacto'
                        : 'No tiene permiso para agregar contactos'
                }
                aria-label="Agregar contacto"
                onClick={openCrearContacto}
            >
                <FaPlus />
            </button>
        ) : null;

    const headerActions =
        expandFilaButton != null || plusButton != null ? (
            <div className="d-flex align-items-center gap-1 flex-shrink-0">
                {expandFilaButton}
                {plusButton}
            </div>
        ) : undefined;

    return (
        <>
            <WindowHeader
                title={panelTitle}
                onTitleClick={() => setModalOpen(true)}
                headerExtraRight={headerActions}
            />
            <GrupoContactoCrearModal
                open={crearOpen}
                grupoId={grupoId}
                empresaId={empresaId}
                onClose={() => setCrearOpen(false)}
                onCreated={refetchContactos}
            />
            <GrupoContactoEditarModal
                open={editOpen}
                contactId={editContactId}
                grupoId={grupoId}
                empresaId={empresaId}
                onClose={() => {
                    setEditOpen(false);
                    setEditContactId(null);
                }}
                onSaved={refetchContactos}
            />
            <GrupoContactoTable
                contactos={list}
                onEditarContacto={tableEditHandler}
                onEliminarContacto={tableEliminarHandler}
            />
            {modalOpen && (
                <ProfaseModal
                    open
                    titleId="grupo-contactos-modal-title"
                    size="xlarge"
                >
                    <div className="d-flex align-items-center justify-content-between gap-2 mb-3 flex-wrap">
                        <h2 id="grupo-contactos-modal-title" className="profase-modal-title m-0">
                            {panelTitleModal}
                        </h2>
                        <div className="d-flex align-items-center gap-2">
                            {headerActions}
                            <button
                                type="button"
                                className="profase-form-btn-secondary btn-sm"
                                onClick={() => setModalOpen(false)}
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                    <GrupoContactoTable
                        contactos={list}
                        onEditarContacto={tableEditHandler}
                        onEliminarContacto={tableEliminarHandler}
                    />
                </ProfaseModal>
            )}
        </>
    );
};

export default GrupoContacto;
